import createIcon from '../../createIcon';

/**
 * @component @name CurrencyYuan
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuMjggMTJIMThWMTRIMTNWMjFIMTFWMTRINlYxMkgxMC43Mkw1IDNINy4zN0wxMiAxMC4yOUwxNi42MyAzSDE5TDEzLjI4IDEyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CurrencyYuan = createIcon('CurrencyYuan', [
  [
    'path',
    {
      d: 'M13.28 12H18V14H13V21H11V14H6V12H10.72L5 3H7.37L12 10.29L16.63 3H19L13.28 12Z',
      key: '11wju1',
    },
  ],
]);

export default CurrencyYuan;
